import React, { Component, Fragment } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import { Dialog, Transition } from '@headlessui/react';
import { BaseTextBox } from '../controls/BaseTextBox';
import Toast from '../controls/BaseToast'
import { ProductOptionCategory } from '../infrastructure/AppConstants';
import { BaseCombobox } from '../controls/BaseCombobox';
import { CheckIcon, BanIcon } from '@heroicons/react/solid'

export default class BaseOptionsViewDialog extends Component {
    constructor(props) {
        super(props);
        this.state = { name: "", code: "", id: "", optionCategory: 0, errMessage: '', index: 0, products: [], selectedEardrumCategoryId: '', eardrumCategories: [], eardrumVersionNotes: [], earmoldVersions: [] };
        this.onClose = this.onClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);        
        this.bindProductOption = this.bindProductOption.bind(this);
        this.handleValueSeleted = this.handleValueSeleted.bind(this);
        this.handleProductCheck = this.handleProductCheck.bind(this);
        this.handlEarmoldVersionCheck = this.handlEarmoldVersionCheck.bind(this);
    }

    handlEarmoldVersionCheck(e) {
        let target = e.target;
        let id = target.id;
        let items = this.state.earmoldVersions;
        for (let i = 0; i < items.length; i++) {
            if (id === items[i].id) {
                items[i].checked = !items[i].checked;
                break;
            }
        }
        this.setState({ earmoldVersions: items });
    }

    handleProductCheck(e) {
        let target = e.target;
        let id = target.id;
        let items = this.state.products;
        for (let i = 0; i < items.length; i++) {
            if (id === items[i].id) {
                items[i].checked = !items[i].checked;
                break;
            }
        }
        this.setState({ products: items });
    }


    async handleValueSeleted(e) {
        var id = e.target.value;
        this.setState({ selectedEardrumCategoryId: id });
    }

    componentDidMount() {
        this.props.onRef(this);

    }

    async populateProductsListData(optionCategory) {
        const token = await authService.getAccessToken();

        let products = this.state.products;
        const responseProduct = await fetch('Product/GetWsaProducts', {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        products = await responseProduct.json();

        this.setState({ products: products, optionCategory: optionCategory });
    }

    async populateEardrumVersionOptionWithNotes(id, isNew = false, productOption, optionCategoryOnCreate) {
        const token = await authService.getAccessToken();

        const responseProduct = await fetch('ProductOption/GetEardrumVersionOption?id=' + id, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        let result = await responseProduct.json();

        if (isNew) {
            this.setState({ optionCategory: optionCategoryOnCreate, eardrumVersionNotes: result.notes, eardrumCategories: result.eardrumCategories, selectedEardrumCategoryId: result.selectedEardrumCategoryId });
        }
        else {
            this.setState({
                name: productOption.name, code: productOption.code, id: id, index: productOption.order,
                optionCategory: productOption.optionCategory, products: productOption.products,
                eardrumVersionNotes: result.notes, eardrumCategories: result.eardrumCategories,
                selectedEardrumCategoryId: result.selectedEardrumCategoryId
            });
        }        
    }

    //Get ear mold version
    async populateAttachEarmoldVersionsData(id, isNew = false, productOption, optionCategoryOnCreate) {        
        const token = await authService.getAccessToken();
        let url = 'ProductOption/GetAttachEarmoldVersions?id=' + id + '&productOptionCategory=' + (isNew === true ? optionCategoryOnCreate : productOption.optionCategory);
        const responseProduct = await fetch(url, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        let result = await responseProduct.json();

        if (isNew) {
            this.setState({ earmoldVersions: result, optionCategory: optionCategoryOnCreate });
        }
        else {
            this.setState({
                name: productOption.name, code: productOption.code, id: id, index: productOption.order,
                optionCategory: productOption.optionCategory, earmoldVersions: result });
        }
    }
    
    onChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        let prefix = 'Note';
        let searchString;
        if (name.startsWith(prefix)) {
            searchString = name.substring(prefix.length); // 截取后面的字符串，包括冒号和空格
            let eardrumVersionNotes = this.state.eardrumVersionNotes;
            for (let i = 0; i < eardrumVersionNotes.length; i++) {
                if (searchString === eardrumVersionNotes[i].id) {
                    eardrumVersionNotes[i].note = value;
                }
            }
            this.setState({
                eardrumVersionNotes: eardrumVersionNotes
            });
        }
        else if (name === 'index') {
            this.setState({
                [name]: value
            });
        }
        else {
            this.setState({
                [name]: value
            });
        }
    }
    async showCreateDialog(optionCategory) {
        await this.bindProductOption(null, true, optionCategory);
    }

    isEarmoldVersionLinkedOption(optionCategory) {
        return optionCategory == ProductOptionCategory.EardrumBteVent ||
            optionCategory == ProductOptionCategory.EarmoldBteTubeDiameter ||
            optionCategory == ProductOptionCategory.EarmoldBteTubeLength ||
            optionCategory == ProductOptionCategory.EarmoldBteLength ||
            //optionCategory == ProductOptionCategory.EarmoldRicReceiverVersion ||
            optionCategory == ProductOptionCategory.EardrumRicVent ||
            optionCategory == ProductOptionCategory.EardrumRicCordLength ||
            optionCategory == ProductOptionCategory.EardrumRicReceiver ||
            optionCategory == ProductOptionCategory.EardrumRicCord;
    }

    async bindProductOption(productOption, isNew = false, optionCategoryOnCreate = -1) {
        if (isNew) {
            if (this.isProductLinkedOption(optionCategoryOnCreate)) {
                this.populateProductsListData(optionCategoryOnCreate);
            }
            else if (this.isEarmoldVersionLinkedOption(optionCategoryOnCreate)) {
                this.populateAttachEarmoldVersionsData('', isNew, productOption, optionCategoryOnCreate);
            }
            else if (optionCategoryOnCreate === ProductOptionCategory.EardrumVersion) {
                this.populateEardrumVersionOptionWithNotes('', isNew, productOption, optionCategoryOnCreate);
            }
            else {
                this.setState({
                    optionCategory: optionCategoryOnCreate
                });
            }
        }
        else {

            let id = productOption.id;
            let optionCategory = productOption.optionCategory;
            if (optionCategory == ProductOptionCategory.EardrumVersion) {
                this.populateEardrumVersionOptionWithNotes(id, isNew, productOption);
            }
            else if (this.isEarmoldVersionLinkedOption(optionCategory)) {
                this.populateAttachEarmoldVersionsData(id, isNew, productOption);
            }            
            else {
                this.setState({
                    name: productOption.name, code: productOption.code, id: id, index: productOption.order,
                    optionCategory: optionCategory, products: productOption.products
                });
            }
            
        }
        
    }
    onClose() {
        this.props.onClose();
        this.clearForm();
    }
    clearForm() {
        this.setState({ name: "", code: "", id: "", optionCategory: "", errMessage: '', index: 0, products: [], selectedEardrumCategoryId: '', eardrumCategories: [], eardrumVersionNotes: [], earmoldVersions: [] });
    }
    async handleOnSubmit(e) {
        e.preventDefault();
        var name = this.state.name;
        var code = this.state.code;
        var index = parseInt(this.state.index, 10) || 0;
        var optionCategory = this.state.optionCategory;
        var id = this.state.id;
        if (!name) {
            this.setState({ errMessage: 'Required' });
            return;
        }

        var productIds = new Array();
        if (this.isProductLinkedOption(optionCategory)) {
            var products = this.state.products;
            for (var i = 0; i < products.length; i++) {
                if (products[i].checked) {
                    productIds.push(products[i].id);
                }
            }
        }

        var earmoldVersionIds = new Array();
        if (this.isEarmoldVersionLinkedOption(optionCategory)) {
            var earmoldVersions = this.state.earmoldVersions;
            for (var i = 0; i < earmoldVersions.length; i++) {
                if (earmoldVersions[i].checked) {
                    earmoldVersionIds.push(earmoldVersions[i].id);
                }
            }
        }

        var selectedEardrumCategoryId = this.state.selectedEardrumCategoryId;
        var versionNotes = this.state.eardrumVersionNotes;

        const token = await authService.getAccessToken();
        let response = null;
        if (id) {
            response = await fetch('ProductOption/Edit', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'id': id,
                    'name': name,
                    'optionCategory': optionCategory,
                    'code': code,
                    "productIds": productIds,
                    'order': index,
                    "eardrumCategoryId": selectedEardrumCategoryId,
                    "eardrumVersionNotes": versionNotes,
                    "earmoldVersionIds": earmoldVersionIds
                })
            })
        } else {
            response = await fetch('ProductOption/Create', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'name': name,
                    'optionCategory': optionCategory,
                    'code': code,
                    "productIds": productIds,
                    'order': index,
                    "eardrumCategoryId": selectedEardrumCategoryId,
                    "eardrumVersionNotes": versionNotes,
                    "earmoldVersionIds": earmoldVersionIds
                })
            })
        }
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    this.onClose();
                    this.props.populateListData();
                }
                else {
                    Toast.warn(data.message);

                }
            }
        }
        else {
            console.error('response.status:' + response.status)
        }

    }

    isProductLinkedOption(optionCategory) {
        return optionCategory === ProductOptionCategory.EnclosureColor ||
            optionCategory === ProductOptionCategory.Attachment ||
            optionCategory === ProductOptionCategory.Vent ||
            optionCategory === ProductOptionCategory.OnlyForRICSeries ||
            optionCategory === ProductOptionCategory.OtherOptions ||
            optionCategory === ProductOptionCategory.AntiEarwaxDevice ||
            optionCategory === ProductOptionCategory.EardrumCategory ||
            optionCategory === ProductOptionCategory.Cord ||
            optionCategory === ProductOptionCategory.ShellCoating
            ;
    }

    renderContent() {
        let optionCategory = this.state.optionCategory;
        if (this.isEarmoldVersionLinkedOption(optionCategory)) {
            return this.renderEardrumSpecialOptionForVersions();
        }
        else if (this.isProductLinkedOption(optionCategory)) {
            return this.renderSpecialOptionForProducts();
        }
        else if (optionCategory === ProductOptionCategory.EardrumVersion) {
            return this.renderSpecialOptionForEardrumVersion();
        }
        else {
            return this.renderNormalOption();
        }
    }

    renderEardrumSpecialOptionForVersions() {
        return (<div className="px-14 pt-6 pb-10 space-y-6">
            <div>
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Name" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="name" placeholder="" value={this.state.name} onChange={this.onChange} errmessage={this.state.errMessage} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Code" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="code" placeholder="" value={this.state.code} onChange={this.onChange} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Index" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="index" placeholder="" value={this.state.index} onChange={this.onChange} />

            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="EardrumVersion" /></label>
                <div className="grid grid-cols-3 gap-2">
                    {this.state.earmoldVersions.map(c =>
                        <div onClick={this.handlEarmoldVersionCheck} id={c.id} key={c.id} className={c.checked ? "mt-3 w-full inline-flex justify-center rounded-md border border-indigo-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            : "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"}>
                            <label>{c.name}</label>
                            <span className="pointer-events-none flex items-center pl-3">
                                {
                                    c.checked ? <CheckIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" /> :
                                        <BanIcon className="h-5 w-5 text-red-500 group-hover:text-red-400" aria-hidden="true" />}
                            </span>
                        </div>
                    )}
                </div>
            </div>

        </div>);
    }

    renderSpecialOptionForProducts() {
        return (<div className="px-14 pt-6 pb-10 space-y-6">
            <div>
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Name" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="name" placeholder="" value={this.state.name} onChange={this.onChange} errmessage={this.state.errMessage} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Code" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="code" placeholder="" value={this.state.code} onChange={this.onChange} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Index" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="number" name="index" placeholder="" value={this.state.index} onChange={this.onChange} />

            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Brand" /></label>
                <div className="grid grid-cols-3 gap-2">
                    {this.state.products.map(c =>
                        <div onClick={this.handleProductCheck} id={c.id} key={c.id} className={c.checked ? "mt-3 w-full inline-flex justify-center rounded-md border border-indigo-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            : "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"}>
                            <label>{c.name}</label>
                            <span className="pointer-events-none flex items-center pl-3">
                                {
                                    c.checked ? <CheckIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" /> :
                                        <BanIcon className="h-5 w-5 text-red-500 group-hover:text-red-400" aria-hidden="true" />}
                            </span>
                        </div>
                    )}
                </div>
            </div>

        </div>);
    }

    renderSpecialOptionForEardrumVersion() {
        return (<div className="px-14 pt-6 pb-10 space-y-6">
            <div>
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Name" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="name" placeholder="" value={this.state.name} onChange={this.onChange} errmessage={this.state.errMessage} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Code" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="code" placeholder="" value={this.state.code} onChange={this.onChange} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Index" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="index" placeholder="" value={this.state.index} onChange={this.onChange} />

            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="EardrumCategory" /></label>
                <BaseCombobox onChangeCapture={this.handleValueSeleted}>
                    {this.state.eardrumCategories && this.state.eardrumCategories.map(p => <option key={p.id} selected={p.id == this.state.selectedEardrumCategoryId} value={p.id}>{p.name}</option>)}
                </BaseCombobox>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Note" /></label>
                <div className="grid grid-cols-3 gap-2">
                    {this.state.eardrumVersionNotes && this.state.eardrumVersionNotes.map(p =>
                        <div>
                            <label>{p.name}</label>
                            <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name={'Note' + p.id} value={p.note} onChange={this.onChange} />
                        </div>)
                    }
                </div>
            </div>
        </div>);
    }

    renderNormalOption() {
        return (<div className="px-14 pt-6 pb-10 space-y-6">
            <div>
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Name" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="name" placeholder="" value={this.state.name} onChange={this.onChange} errmessage={this.state.errMessage} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Code" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="code" placeholder="" value={this.state.code} onChange={this.onChange} />
            </div>
            <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Index" /></label>
                <BaseTextBox classnames="min-w-0 w-3/4 mt-1" type="text" name="index" placeholder="" value={this.state.index} onChange={this.onChange} />

            </div>
        </div>);
    }

    render() {
        const open = this.props.open;
        //var dialogStyle = "inline-block align-bottom bg-white rounded-lg text-left shadow-xl  overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full";
        //if (this.state.optionCategory === ProductOptionCategory.EnclosureColor ||
        //    this.state.optionCategory === ProductOptionCategory.Attachment ||
        //    this.state.optionCategory === ProductOptionCategory.Vent ||
        //    this.state.optionCategory === ProductOptionCategory.OnlyForRICSeries ||
        //    this.state.optionCategory === ProductOptionCategory.OtherOptions ||
        //    this.state.optionCategory === ProductOptionCategory.AntiEarwaxDevice ||
        //    this.state.optionCategory === ProductOptionCategory.EardrumCategory ||
        //    this.state.optionCategory === ProductOptionCategory.EardrumVersion) {
        //    dialogStyle = "inline-block align-bottom bg-white rounded-lg text-left shadow-xl  overflow-hidden transform transition-all";
        //}

        return (
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    static
                    className="fixed z-10 inset-0 overflow-y-auto"
                    open={open}
                    onClose={this.onClose}
                >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >


                            <form onSubmit={this.handleOnSubmit} style={{ width: '100vw' }}>
                                <div className="inline-block align-bottom bg-white rounded-lg text-left shadow-xl  overflow-hidden transform transition-all" style={{ minWidth: "50%" }}>
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4   border-b border-gray-200">
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900"><FormattedMessage id="BaseOption" /></Dialog.Title>
                                        </div>
                                    </div>
                                    {this.renderContent()}
                                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                            onClick={this.onClose}><FormattedMessage id="Cancel" /></button>
                                        <button type="submit"
                                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"><FormattedMessage id="Submit" /></button>

                                    </div>
                                </div>
                            </form>

                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root >
        )
    }
}